"use client";

import { useProductsContext } from "@/src/provider";
import Box from "@mui/material/Box";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import NewBTemplateTest from "../newBTemplateTest";
import classnames from "classnames";
import styles from "../index.module.scss";
import VerticalSwiper from "../VerticalSwiper";
import useOptimizedScroll from "@/src/hooks/useOptimizedScroll";

export default function StickyContainer() {
    const PRE_SHOW_INDEX = 2;

    const products = useProductsContext((state) => state.productData.data);
    const [isSticky, setSticky] = useState(false);
    const cloneRef = useRef<HTMLDivElement>(null);

    const handleScroll = useCallback(() => {
        if (!cloneRef.current) return;
        const rect = cloneRef.current.getBoundingClientRect();
        if (rect.top <= 0 && !isSticky) {
            setSticky(true);
        } else if (rect.top > 0 && isSticky) {
            setSticky(false);
        }
    }, []);
    const filterViews = (status: boolean) => {
        setSticky(false)
    };

    useOptimizedScroll({ onScroll: handleScroll });

    const secondProductRef = useRef<HTMLDivElement>(null);

    const CloneProductsItem = useMemo(() => {
        if (!products.length || products.length < PRE_SHOW_INDEX || products.length < 2) return null;
        const item = products[PRE_SHOW_INDEX];

        return (
            <Box
                id="sticky-clone"
                ref={cloneRef}
                style={{
                    background: "#f2f2f2",
                    width: "100vw",
                    height: "100dvh",
                }}
            >
                <NewBTemplateTest data={item} filterViews={filterViews} />
                {/* {!isSticky && <NewBTemplateTest data={item}  filterViews={filterViews}/>} */}
            </Box>
        );
    }, [products]);

    const TopProductsItem = useMemo(() => {
        if (!products.length) return null;
        return products.slice(0, PRE_SHOW_INDEX).map((item, index) => (
            <Box
                key={`top-${index}`}
                ref={index === 1 ? secondProductRef : undefined}
                className={index === 1 ? styles["second-product"] : ""}
                id="top-product"
            >
                <NewBTemplateTest data={item} filterViews={filterViews} />
            </Box>
        ));
    }, [products]);
    const BTemplateSwiper = useMemo(() => {
        if (products.length < 2) return null;
        return (<Box
            id="BTemplateSwiper"
            style={{
                width: "100vw",
                height: products.length > 0 ? "100dvh" : "0",
                backgroundColor: "#f2f2f2",
                position: isSticky ? "fixed" : "relative",
                visibility: isSticky ? "visible" : "hidden",
                top: 0,
                left: 0,
                transition: "all 0.3s ease-in-out",
                zIndex: isSticky ? 1000 : 0,
            }}
            className={classnames(styles.carouselContainer)}
            onTouchMove={(e) => e.stopPropagation()}
        >
            <VerticalSwiper
                PRE_SHOW_INDEX={PRE_SHOW_INDEX}
                setSticky={setSticky}
                secondProductRef={secondProductRef}
            />
        </Box>)
    }, [isSticky, products.length]);

    return (
        <div>
            {TopProductsItem}
            {CloneProductsItem}
            {BTemplateSwiper}
        </div>
    );
}
